import { render, staticRenderFns } from "./ShippingPlanDetail.vue?vue&type=template&id=44b3d439&scoped=true&"
import script from "./ShippingPlanDetail.vue?vue&type=script&lang=js&"
export * from "./ShippingPlanDetail.vue?vue&type=script&lang=js&"
import style0 from "./ShippingPlanDetail.vue?vue&type=style&index=0&id=44b3d439&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b3d439",
  null
  
)

export default component.exports